/**
 * Randomize array element order via Fisher-Yates algorithm
 * @param {Array} array - array to shuffle
 * @returns {Array} - newly shuffled array
 */
export function arrayShuffle(array) {
    // Create a copy of the original array to avoid mutating it
    const arrayCopy = [...array];

    let currentIndex = arrayCopy.length;
    let randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [arrayCopy[currentIndex], arrayCopy[randomIndex]] = [
            arrayCopy[randomIndex],
            arrayCopy[currentIndex],
        ];
    }

    return arrayCopy;
}
